export class RequestInvoiceNumber {
    ID?: number;
    RequestID?: number;
    Number: string;
}

export default RequestInvoiceNumber;